import apiService from '../Api'
import { EventTabDetail, EventTabsResponse, EventTabStatus } from './types'

export type EventTabsParams = {
  search?: string
  status?: EventTabStatus
  with_removals?: 1
  page?: number
  page_size?: number
}

/** Comandas do evento: o que cada uma consumiu e pagou, e quem lançou ou removeu cada item. */
export class EventTabsService {
  async list(eventId: number, params: EventTabsParams): Promise<EventTabsResponse> {
    return apiService.get(`/events/${eventId}/tabs`, { params }).then((res) => res.data)
  }

  async get(eventId: number, checkinId: number): Promise<EventTabDetail> {
    return apiService.get(`/events/${eventId}/tabs/${checkinId}`).then((res) => res.data)
  }
}
